import React, { useContext } from "react";

import FuncionesContext, { getAtributo } from "../../../context/FuncionesContext";

function EnlaceADescarga({ id_elemento, data, cab, e, hijos }) {
  const { descargar } = useContext(FuncionesContext);
  const ruta = e + data[cab.id_a + "_archivo_nombre"];
  const boton_texto = getAtributo("boton_texto", data, cab)

  return (
    <div
      id={id_elemento}
      className={`Listado_Switch_Enlace ${data[cab.id_a + "_className"]}`}
      style={{}}
      onClick={() => descargar(ruta)}
    >
      <div
        style={{
          textAlign: cab.align ?? "center",
        }}
      >
        {cab.imagen_url ? (
          <img
            style={{ cursor: "pointer" }}
            height={"40px"}
            src={cab.imagen_url}
            alt="imagen"
          />
        ) : (
          <>
            {boton_texto}
          </>
        )}

        {hijos}
      </div>
    </div>
  );
}

export default EnlaceADescarga;
